import { getActiveDocumentType } from "Areas/Sidebar/Documents/redux/selectors";
import { connect } from "react-redux";
import DocumentDetails from "./documentDetails";
const mapStateToProps = (state) => {
    const activeDocumentType = getActiveDocumentType(state);
    return {
        documentType: activeDocumentType
    };
};
export default connect(mapStateToProps)(DocumentDetails);
